module.exports = "<div class=\"wrapper\">\n  <button (click)=\"goToHome()\" class=\"back-to-home\">\n    <strong>{{ backButtonLabel | translate: { name: currentPatient.firstName + ' ' + currentPatient.lastName } }}</strong>\n  </button>\n\n  <ol class=\"steps\">\n    <li class=\"action\" *ngFor=\"let step of breadcrumbSteps\" (click)=\"goToStep(step)\" [ngClass]=\"{ '-current': isCurrentStep(step), '-done': isStepCompleted(step)}\">\n      <span class=\"name\">{{ step.label | translate }}</span>\n    </li>\n  </ol>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./ng2/main/top-navigation/top-navigation.component.html
// module id = 1232
// module chunks = 0